// Amplify uses HttpOnly cookies automatically — no Authorization header needed.
export async function getAuthHeaders(): Promise<Record<string, string>> {
  return {};
}
